import { Question } from "~/types/questionTypes"

function todaysDateAsStr(): string {
  const date = new Date()
  let month = "" + (date.getMonth() + 1)
  let day = "" + date.getDate()
  const year = date.getFullYear()

  if (month.length < 2) month = "0" + month
  if (day.length < 2) day = "0" + day

  return `${year}-${month}-${day}`
}

export const autofillFields = (
  questions: Question[]
): Record<string, string | string[]> => {
  const autofillData: Record<string, string | string[]> = {}
  for (const q of questions) {
    let isDate = q.fieldType === "text" && q.fieldLabel.toLowerCase() === "date"
    if (q.fieldAnnotation.includes("@TODAY")) isDate = true

    if (isDate) {
      autofillData[q.fieldName] = todaysDateAsStr()
      continue
    }
  }

  return autofillData
}
